/******************* 
@Purpose : We can use following api calls and can change api name easily
@Author : INIC
******************/
module.exports = {
  HOME: "/",
  VERIFY_EMAIL: "/verify-email",
  PERSONAL_DETAILS: "/personal-details",
};
